module.exports = __webpack_public_path__ + "img/logo_dark.1905f3e5.png";